export function stockAvailability(inventoryCount) {
  if (!Number.isFinite(inventoryCount)) return null;
  if (inventoryCount <= 0) return { label: "Udsolgt", level: "out" };
  if (inventoryCount <= 3) {
    return { label: `Kun ${inventoryCount} tilbage`, level: "low" };
  }
  return { label: "På lager", level: "available" };
}
